var Cookie = require('./dom').Cookie;

class Preferences {
    v = {};
    #callbacks = [];

    get(key, default_value) {
        return this.v[key] != void 0 ? this.v[key] : default_value
    }

    _set(key, value) {
        return this.v[key] = value;
    }

    set(key, value) {
        if (value == void 0) {
            this.del(key);
            return void 0;
        }
        for (let f of this.#callbacks[key] ?? [])
            f(value);
        return this._set(key, value);
    }

    del(key) {
        for (let f of this.#callbacks[key] ?? [])
            f(void 0);
        var old = this.v[key];
        delete this.v[key];
        return old;
    }

    onchange(key, default_value, callback) {
        this.#callbacks[key] ??= [];
        this.#callbacks[key].push((v) => callback(v ?? default_value));
        callback(this.get(key, default_value)); // Kick once.
    }
}

class CookiePreferences extends Preferences {
    constructor() {
        super();
        for (var key in Cookie.list) {
            var m, value = Cookie.list[key];
            if (m = key.match(/^pref_(.*)$/))
                try {
                    this.v[m[1]] = JSON.parse(value);
                } catch(e) {
                    this.v[m[1]] = value;
                }
        }
    }
    _set(key, value) {
        Preferences.prototype._set.call(this, key, value);
        Cookie.set("pref_"+key, JSON.stringify(value), "10y");
        return value;
    }

    del(key) {
        var old = Preferences.prototype.del.call(this, key);
        Cookie.set("pref_"+key, void 0);
        return old;
    }
}

var Prefs = new CookiePreferences();

(function(){ // Upgrade old cookie names to new preference names
    var upgrade = [
        'order',
        'cardset',
        'cardback'
    ];

    Cookie.set("moves", void 0);

    for (var ui in upgrade)
        if (Cookie.list[upgrade[ui]]) {
            Prefs.set(upgrade[ui], Cookie.list[upgrade[ui]]);
            Cookie.set(upgrade[ui], void 0);
        }
})();

module.exports = Prefs;
var Cookie = require('./dom').Cookie;

class Preferences {
    v = {};
    #callbacks = [];

    get(key, default_value) {
        return this.v[key] != void 0 ? this.v[key] : default_value
    }

    _set(key, value) {
        return this.v[key] = value;
    }

    set(key, value) {
        if (value == void 0) {
            this.del(key);
            return void 0;
        }
        for (let f of this.#callbacks[key] ?? [])
            f(value);
        return this._set(key, value);
    }

    del(key) {
        for (let f of this.#callbacks[key] ?? [])
            f(void 0);
        var old = this.v[key];
        delete this.v[key];
        return old;
    }

    onchange(key, default_value, callback) {
        this.#callbacks[key] ??= [];
        this.#callbacks[key].push((v) => callback(v ?? default_value));
        callback(this.get(key, default_value)); // Kick once.
    }
}

class CookiePreferences extends Preferences {
    constructor() {
        super();
        for (var key in Cookie.list) {
            var m, value = Cookie.list[key];
            if (m = key.match(/^pref_(.*)$/))
                try {
                    this.v[m[1]] = JSON.parse(value);
                } catch(e) {
                    this.v[m[1]] = value;
                }
        }
    }
    _set(key, value) {
        Preferences.prototype._set.call(this, key, value);
        Cookie.set("pref_"+key, JSON.stringify(value), "10y");
        return value;
    }

    del(key) {
        var old = Preferences.prototype.del.call(this, key);
        Cookie.set("pref_"+key, void 0);
        return old;
    }
}

var Prefs = new CookiePreferences();

(function(){ // Upgrade old cookie names to new preference names
    var upgrade = [
        'order',
        'cardset',
        'cardback'
    ];

    Cookie.set("moves", void 0);

    for (var ui in upgrade)
        if (Cookie.list[upgrade[ui]]) {
            Prefs.set(upgrade[ui], Cookie.list[upgrade[ui]]);
            Cookie.set(upgrade[ui], void 0);
        }
})();

module.exports = Prefs;
